export default __webpack_public_path__ + "static/faith-25a5b60863ffb77e2bac697521140437.png";